export const GET_PORT_OF_LOADINGS = "GET_PORT_OF_LOADINGS";
export const GET_PORT_OF_LOADING = "GET_PORT_OF_LOADING";
export const ADD_PORT_OF_LOADING = "ADD_PORT_OF_LOADING";
export const DELETE_PORT_OF_LOADING = "DELETE_PORT_OF_LOADING";
export const UPDATE_PORT_OF_LOADING = "UPDATE_PORT_OF_LOADING";
